// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlanActiveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlanActiveInput — body for POST /subscriptions/plans/{id}/active.
 *
 * Toggles a plan's active flag (D3 — makes plan retirement reversible from the
 * staff UI, mirroring AiCredits_PackActiveInput / packs set_active).
 *
 * Required fields:
 *   active (int) — 0 or 1
 */
import { registerContract } from './validate'

export interface Subscriptions_PlanActiveInput {
active: number
}

registerContract('Subscriptions_PlanActiveInput', {
  active: { type: 'number',  required: true },
})
